import React from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";


function App(props) {
    const [data, setData] = React.useState("در حال اسکن بارکد");

    return (
        <>
            <BarcodeScannerComponent
                width='100%'

                onUpdate={(err, result) => {
                    if (result) {
                        if(result.text.length === 14 ) {
                            props.setCode(result.text)
                            props.setShowScan(false)
                        }
                    }
                    else{
                        setData("در حال اسکن بارکد");
                    }

                }}
            />
            <div className='alert alert-warning text-center text-small-3 py-1 my-0'>
                 <span className="spinner-grow spinner-grow-sm text-warning mx-3 " role="status">

                </span>
                {data}

            </div>
            {/*        <div>
                <button
                onClick={() => {
                    let code = '88662061463523';
                    if(code.length === 14 ) {

                        props.setCode('88662061463523')
                        props.setShowScan(false)
                    }

                }}
                >
                    Close it
                </button>
            </div>*/}
        </>
    );
}

export default App;